import { useEffect } from "react";
import { Alphabet, ModifierKeys } from "./types";

interface Props {
  handleFunc: () => void;
  specialCharacter: ModifierKeys;
  charater: Alphabet;
}

export const useHotKey = ({
  handleFunc,
  specialCharacter,
  charater,
}: Props) => {
  useEffect(
    () => {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e[specialCharacter] && e.key === charater) {
          //to avoid selecting contents of page
          const style = document.createElement("style");
          style.innerHTML = `
                // //to disable texts getting selected in browser
          -webkit-user-select: none; /* Chrome, Safari, and Opera */
          -moz-user-select: none; /* Firefox */
          -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none;
              
              `;

          document.head.appendChild(style);
          handleFunc();
        }
      };

      document.addEventListener("keydown", handleKeyDown);

      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    },
    // eslint-disable-next-line
    [specialCharacter, charater]
  );
};
